<template>
  <div class="editor">
    <div class="editor-head">
      <button class="editor-button" @click="isLinkShow = !isLinkShow">
        <v-icon>link</v-icon>
        <div class="tooltip">插入超連結</div>
      </button>
      <button class="editor-button" v-if="titleButton">
        <v-icon>title</v-icon>
        <div class="tooltip">設為標題</div>
      </button>
      <button class="editor-button" v-if="photoButton">
        <v-icon>photo</v-icon>
        <div class="tooltip">插入圖片</div>
      </button>
    </div>
    <div
      v-once
      ref="textArea"
      class="editor-body"
      contenteditable
      :data-text="placeholder"
      :style="{ 'min-height': `${bodyMinHeight}px` }"
      v-html="value"
      @input="changeText"
      @focus="isLocked = true"
      @blur="isLocked = false"
    ></div>

    <!-- modal link -->
    <div class="editor-link-modal" v-if="isLinkShow">
      <!-- 文字 -->
      <label class="d-flex align-center mb-10px">
        <div class="h4 mr-5">文字</div>
        <div class="form-input-group flex-grow-1">
          <input type="text" placeholder="文字內設定連結" />
        </div>
      </label>
      <!-- 連結 -->
      <label class="d-flex align-center mb-10px">
        <div class="h4 mr-5">連結</div>
        <div class="form-input-group flex-grow-1">
          <div class="prepend-icon" style="top: 45%;">
            <v-icon>link</v-icon>
          </div>
          <input type="text" class="pl-42px" />
        </div>
      </label>
      <!-- actions -->
      <div class="text-right mb-10px">
        <button class="btn mr-10px" @click="cancelLink">取消連結</button>
        <button class="btn btn-primary" @click="setLink">設定連結</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bodyMinHeight: {
      type: Number,
      default: 150,
    },
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    titleButton: {
      type: Boolean,
      default: false,
    },
    photoButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLinkShow: false,
      isLocked: false,
    };
  },
  watch: {
    value() {
      if (!this.isLocked) {
        this.$refs.textArea.innerHTML = this.value;
      }
    },
  },
  methods: {
    // link
    cancelLink() {
      this.isLinkShow = false;
    },
    setLink() {
      this.isLinkShow = false;
    },
    changeText() {
      this.$emit('input', this.$refs.textArea.innerHTML);
    },
  },
};
</script>

<style lang="scss">
.editor {
  position: relative;
  border-radius: 4px;
  border: solid 1px #d7dee7;
  background-color: #ffffff;

  // placeholder
  [contentEditable='true']:empty:not(:focus):before {
    content: attr(data-text);
    color: $gray-600;
  }

  // head
  &-head {
    box-shadow: inset 0 -1px 0 0 #d7dee7;
  }
  &-button {
    position: relative;
    width: 32px;
    height: 32px;
    border-right: solid 1px #d7dee7;
    &:focus {
      outline: 2px solid $brand-01-emphasis;
    }

    i {
      font-size: 20px;
    }

    &.link:hover::before {
      content: '';
    }
    & .tooltip {
      position: absolute;
      // display: flex;
      display: none;
      justify-content: center;
      align-items: center;
      top: -35px;
      left: 50%;
      transform: translateX(-50%);
      min-width: 72px;
      height: 28px;
      opacity: 0.9;
      font-size: 12px;
      color: white;
      border-radius: 3px;
      background-color: #101112;
    }
    &:hover .tooltip {
      display: flex;
    }
  }
  // body
  &-body {
    width: 100%;
    min-height: 150px;
    padding: 8.4px 12px;

    &:focus {
      outline: 2px solid $brand-01-emphasis;
    }

    h1,
    h2,
    h3,
    h4,
    h5 {
      margin-top: 20px;
      margin-bottom: 10px;
    }

    img {
      width: 100%;
    }
  }
}

.editor-link-modal {
  position: absolute;
  top: 40px;
  width: 392px;
  height: 170px;
  padding: 10px 20px 0px 20px;
  border-radius: 8px;
  box-shadow: 0 16px 16px -2px rgba(4, 48, 71, 0.1),
    0 0 1px 0 rgba(4, 48, 71, 0.1);
  background-color: #ffffff;
  z-index: 1;
}
</style>
